import React, { useEffect, useState } from "react";
import Table from "../../components/table";

function PublicDataTable(props: any) {
  const [data, setData] = useState<any>();
  const [total, setTotal] = useState<number>();

  useEffect(() => {
    if (props.data) {
      const newValue =
        props.data &&
        props.data.map((valueItem: any) => {
          valueItem.availabilityValue = {
            availability: valueItem.availability,
            availability_date: valueItem.availability_date,
            availability_lastUpdatedDate:
              valueItem.availability_lastUpdatedDate,
            availability_week: valueItem.availability_week,
          };
          return valueItem;
        });
      setData(newValue);
      setTotal(props.total);
    }
  }, [props]);

  const pageChange = (data: any) => { };

  const pageSize = (pageSize: any, pageNumber: number) => {
    props.pageSize(pageSize, pageNumber);
  };

  return (
    <section className="tableStyle">
      <Table
        getTablesValues={props.getTablesValues}
        pageSize={pageSize}
        data={data}
        rowClick={""}
        total={total}
        pageChange={pageChange}
        type={"publicDatabase"}
        setSort={props.setSort}
        applySort={props.applySort}
      />
    </section>
  );
}

export default PublicDataTable;
